export enum LogType {
    ImportExport = 'imports_exports',
    Transformer = 'transformers',
    FeedAlerts = 'feed_alerts',
    Change = 'change_logs',
    ExportEventQueue = 'export_event_queue',
    EDRTS = 'ebs_logs'
}
